<template>
  <div
    class="area-block d-flex align-content-between flex-wrap"
    v-bind:class="{ selected: value ? true : false }"
  >
    <div class="d-flex w-100">
      <div class="area-title">{{ title }}</div>
      <div @click="checkSelect(!value)" class="select-icon ml-auto pl-1">
        <img alt="Aggiungi" src="../assets/images/add.svg" v-show="!value" />
        <img alt="Rimuovi" src="../assets/images/remove.svg" v-show="value" />
      </div>
    </div>
    <div
      class=""
      style="margin-right: 1px"
      v-for="sdg in sdgList"
      :key="sdg.id"
    >
      <div class="mt-auto  d-flex flex-row">
        <img
          class="sdg-icon"
          :alt="sdg.title"
          :src="sdg.icon"
          v-show="value ? true : false"
        />
        <img
          class="sdg-icon"
          :alt="sdg.title"
          :src="sdg.iconFull"
          v-show="!value ? true : false"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AreaSelector",
  props: {
    title: String,
    areaId: Number,
    sdgList: Array,
    value: Boolean
  },
  mounted() {
    this.selected = this.value;
  },
  methods: {
    checkSelect(selected) {
      this.$emit("input", selected);
    }
  }
};
</script>

<style scoped></style>
